var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-exclamation-triangle fa-lg icon-button",attrs:{"title":"Visualizar Mensagem de Erro de Integração"},on:{"click":function($event){$event.stopPropagation();return _vm.exibirMensagem()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }